export const sizeSpacing10 = "96px";
export const sizeSpacing11 = "120px";
export const sizeSpacing12 = "160px";
export const sizeSpacing01 = "4px";
export const sizeSpacing02 = "8px";
export const sizeSpacing03 = "12px";
export const sizeSpacing04 = "16px";
export const sizeSpacing05 = "24px";
export const sizeSpacing06 = "32px";
export const sizeSpacing07 = "48px";
export const sizeSpacing08 = "64px";
export const sizeSpacing09 = "72px";